module.exports = __webpack_public_path__ + "assets/img/d5f1749a0c128755f7cc84596f3ad6cb.png";